/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_At_MostInputs */

const en_scrape_router_at_most = /** @type {(inputs: Scrape_Router_At_MostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`at most`)
};

const zh_hans1_scrape_router_at_most = /** @type {(inputs: Scrape_Router_At_MostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最多`)
};

const pt_br2_scrape_router_at_most = /** @type {(inputs: Scrape_Router_At_MostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no máximo`)
};

const es_scrape_router_at_most = /** @type {(inputs: Scrape_Router_At_MostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`como máximo`)
};

const fr_scrape_router_at_most = /** @type {(inputs: Scrape_Router_At_MostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`au plus`)
};

const de_scrape_router_at_most = /** @type {(inputs: Scrape_Router_At_MostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`höchstens`)
};

const ru_scrape_router_at_most = /** @type {(inputs: Scrape_Router_At_MostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`не более`)
};

const it_scrape_router_at_most = /** @type {(inputs: Scrape_Router_At_MostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`al massimo`)
};

/**
* | output |
* | --- |
* | "at most" |
*
* @param {Scrape_Router_At_MostInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_at_most = /** @type {((inputs?: Scrape_Router_At_MostInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_At_MostInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_at_most(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_at_most(inputs)
	if (locale === "es") return es_scrape_router_at_most(inputs)
	if (locale === "fr") return fr_scrape_router_at_most(inputs)
	if (locale === "de") return de_scrape_router_at_most(inputs)
	if (locale === "ru") return ru_scrape_router_at_most(inputs)
	if (locale === "it") return it_scrape_router_at_most(inputs)
	return en_scrape_router_at_most(inputs)
});